// extracted by mini-css-extract-plugin
export default {"container":"forgotPasswordLayout_container__ZYD9T","logoContainer":"forgotPasswordLayout_logoContainer__nee4o","carretLeft":"forgotPasswordLayout_carretLeft__hNPZP"};